import React, { useEffect, useMemo } from 'react';
import { useSelector } from "umi";
import { Select } from 'tea-component';
import { EntryProps } from '../interface';
import { checkNullString } from '@/pages/datalab/utils/utils';
import { FilterStringOptions } from '@dbl/core/filter';
import { OptionPageSize } from '@/pages/datalab/components/SortableDrag/configration';
import { ListCheckbox } from '../widgets/ListCheckbox';
import { with404Fallback } from '@/pages/datalab/services/common';
import { getColunmOptions } from '@dbl/services/global';
import type { IOptionType } from '@dbl/core/dataSource';
export const FilterStringEntry = (props: EntryProps) => {
  const { column, onChange, handle, isEn, customOptionLoader } = props;
  const { gameCode } = useSelector((state: any) => ({ gameCode: state.datalab?.gameCode }));

  const { notifyItems } = handle;
  const operationValue = useMemo(() => {
    if (checkNullString(column.operation)) {
      return FilterStringOptions[0].value;
    }
    return column.operation ?? '';
  }, [column.operation]);

  useEffect(() => {
    const newOperation = operationValue;
    onChange(newOperation, column.column_value || []);
  }, [operationValue]);

  const filterOptions = useMemo(
    () =>
      FilterStringOptions.map((opt) => ({
        value: opt.value,
        text: isEn ? (opt.text_en ?? opt.text) : opt.text,
        text_en: opt.text_en ?? opt.text,
      })),
    [isEn],
  );
  const listOptions = useMemo(
    () =>
      column?.options_all?.map((opt) => ({
        value: opt.value,
        text: opt.text ?? '',
        text_en: opt.text_en ?? opt.text ?? '',
      })),
    [column?.options_all],
  );

  // 选项加载函数：优先使用自定义加载器，否则使用默认接口
  const handleOptionLoad = async (): Promise<IOptionType[]> => {
    if (customOptionLoader) {
      return await customOptionLoader(column, gameCode || '');
    }
    // 默认使用 getColunmOptions 接口
    const optRes: any = await with404Fallback(getColunmOptions({
      table_id: column.table_id,
      game_code: gameCode || '',
      dim_name: column.column_name,
      page_no: 1,
      page_size: OptionPageSize,
      query_type: 0,
      dimension_setting: column.dimension_setting,
    }), { value_list: [], total_size: 0 },);
    const optionAll: IOptionType[] = optRes.value_list.map((item: any) => ({
      text: item.display || item.value || '',
      value: item.value,
      text_en: item.display_en || item.value || '',
    }));
    return optionAll;
  };

  return (
    <>
      <Select
        className="fs-entry-string-operation"
        appearance="button"
        options={filterOptions}
        value={operationValue}
        onChange={(value) => {
          if (value === column.operation) {
            return;
          }
          column.options_all = [];
          onChange(value, column.column_value || []);
        }}
      />
      <ListCheckbox
        className="fs-entry-string-values"
        selectName={isEn ? column.column_name : column.column_display}
        selectValues={column.column_value ?? []}
        onChange={(values: string[], text?: string) => {
          onChange(column.operation, values, text);
        }}
        options={listOptions ?? []}
        onOptionLoad={handleOptionLoad}
        onOptionResult={(options: IOptionType[]) => {
          column.options_all = options;
          notifyItems();
        }}
      />
    </>
  );
};
